import { LOCAL_STORAGE_NAMES, ROUTES } from '../constants/constants';
import { FeatureFlags, FeatureSelectionTab, StartModule } from '../interface/featureSelection';
import { hasUserPreference, readUserPreference, storeUserPreference } from './userPreferences';

export const DEFAULT_START_MODULE: StartModule = FeatureSelectionTab.dashboard;

const START_MODULE_ROUTES: Record<StartModule, string> = {
  [FeatureSelectionTab.dashboard]: ROUTES.DASHBOARD,
  [FeatureSelectionTab.timer]: ROUTES.TIMER_LIST,
  [FeatureSelectionTab.transactions]: ROUTES.TRANSACTION_LISTING,
  [FeatureSelectionTab.tasks]: ROUTES.TASKS_LIST,
  [FeatureSelectionTab.conflictSearch]: ROUTES.CONFLICT_SEARCH,
  [FeatureSelectionTab.customers]: ROUTES.CUSTOMER_LISTING,
  [FeatureSelectionTab.matters]: ROUTES.MATTERS_LISTING,
  [FeatureSelectionTab.invoicing]: ROUTES.INVOICING,
  [FeatureSelectionTab.workTimes]: ROUTES.WORK_TIME,
};

export const isStartModule = (value: unknown): value is StartModule =>
  typeof value === 'number' && value in START_MODULE_ROUTES;

/** A start module that is switched off, unknown or missing falls back to Dashboard, which is always on. */
export const resolveStartModule = (features: FeatureFlags, startModule: unknown): StartModule =>
  isStartModule(startModule) && features[startModule] ? startModule : DEFAULT_START_MODULE;

export const getStartModuleRoute = (startModule: StartModule): string =>
  START_MODULE_ROUTES[startModule];

/** Each user is asked for analytics consent once, straight after workspace setup; once they have answered, the start module opens. */
export const getRouteAfterWorkspaceSetup = (
  startModule: StartModule,
  userId: string | undefined,
): string =>
  hasUserPreference(LOCAL_STORAGE_NAMES.appAnalyticsPermission, userId)
    ? getStartModuleRoute(startModule)
    : ROUTES.ANALYTICS;

export const readStoredStartModule = (userId?: string): StartModule =>
  readUserPreference(LOCAL_STORAGE_NAMES.startModule, userId, isStartModule, DEFAULT_START_MODULE);

export const storeStartModule = (userId: string, startModule: StartModule): void =>
  storeUserPreference(LOCAL_STORAGE_NAMES.startModule, userId, startModule);
